import { jsx } from 'react/jsx-runtime';
import { createContext, useEffect } from 'react';
import { isMobile } from '@dynamic-labs/utils';
import { useResponseHandlers } from './useResponseHandlers.js';

const PhantomRedirectContext = createContext(undefined);
const PhantomRedirectContextProvider = ({ children, }) => {
    const { phantomRedirectConnector, handleConnectResponse, handleUserResponse, } = useResponseHandlers();
    useEffect(() => {
        if (!phantomRedirectConnector || !isMobile()) {
            return;
        }
        const params = new URLSearchParams(window.location.search);
        if (params.has('error')) {
            // implement error handling
            return;
        }
        // handle response of connect method
        if (params.has('phantom_encryption_public_key')) {
            handleConnectResponse();
            return;
        }
        // handle response of the following methods:
        // signMessage, signTransaction, signAndSendTransaction or signAllTransactions
        if (params.has('data')) {
            handleUserResponse();
            return;
        }
    }, [handleConnectResponse, handleUserResponse, phantomRedirectConnector]);
    return (jsx(PhantomRedirectContext.Provider, { value: {
            phantomRedirectConnector,
        }, children: children }));
};

export { PhantomRedirectContext, PhantomRedirectContextProvider };
